<template>
  <div id="main" class="app-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      theme: this.$store.state.app.themeColor,
    };
  },
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>

<style lang="less">
html,
body {
  width: 100%;
  height: 100%;
  background: #f0f0f0;
  overflow: hidden;
  min-width: 1370px !important;

  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;

  -webkit-user-select: none; /* Chrome, Safari, Opera */
  -moz-user-select: none;    /* Firefox */
  -ms-user-select: none;    /* Internet Explorer/Edge */
  user-select: none;        /* Standard syntax */
}
.app-main {
  width: 100%;
  height: 100%;
}
.ivu-page-options-sizer{
  .ivu-select-dropdown{
    width: 90px !important;
  }
  //   max-height: 110px !important;
}
// 主内容区域头部按钮及表单
.mainHeader{
  height: 34px;
  line-height: 34px;
  .mainHeaderL {
    width: auto;
  }
  .mainHeaderR {
    width: auto;
    label {
      font-size: 12px;
      font-weight: 100;
    }
    &>label{
      font-weight: 500;
    }
    &>div{
      margin-right: 10px;
      &:last-child{ margin-right: 0;}
    }
  }
}
.single-page>div{
  min-width: 1150px;
}
// .single-page>div>div>div>div.ivu-card-body{
//   min-width: 1150px;
// }
// 主内容区域底部按钮及分页
.mainFooter{
  padding:16px 0 0;
  .mainFooterL {
    width: auto;
    &>div{
      margin-right: 10px;
    }
  }
  .mainFooterC{
    color:#ccc;
    text-align: center;
    font-size:14px
  }
  .mainFooterR {
    width: auto;
  }
}
// table限制内容不超过两行
:global(.ivu-table-cell){
      display: block;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      overflow: hidden;
      -webkit-box-orient: vertical;
      word-break: break-all;
}
// 统一表格中操作的按钮大小
.ivu-table-cell .ivu-btn>.ivu-icon{
  line-height: 23px;
}

// 设置表格的最大高度和滚动条
.ivu-table-body{
  // max-height: calc( 100vh - 360px );
  // height: auto !important;
  // overflow: auto;
}

.ivu-table-cell .ivu-btn{margin-top:1px !important;margin-bottom:1px !important;}

// 去除分页配置中的右边距
.ivu-page-options-sizer{
  margin-right: 0;
}
.textStyle {
    text-align: center;
    margin: 20px auto;
}
.inUsed{
    background: #F9F9FA;
    padding: 10px;
    font-size: 14px;
    border-radius: 4px;
}
// 部门组件别的浏览器样式修改
.is-focusable:focus {
  outline: none;
}

// 禁止选择框中的清空按钮旋转
.ivu-select-visible .ivu-icon-ios-close{
  transform: rotate(0);
}

 /* 自定义工具栏样式 */
 .custom-toolbox {
    position: absolute;
    background-color: #f0f0f0;
    padding: 5px;
    border: 1px solid #ccc;
    z-index: 1000; /* 确保工具栏在最上层 */
}

.w-e-toolbar{
  position: absolute !important;
  top: 0%;
  left: 0%;
  display: none !important;
}

.showToolbar{
  display: flex !important;
}

.w-e-toolbar[type="1"]{
  display: flex !important;
}

.editorContainer{
  border-top: 1px solid #c9d8db;
}

.w-e-text-container{
  border: none !important;
}

</style>




// WEBPACK FOOTER //
// src/App.vue